import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import CustomTable from '../../components/Shared/CustomTable'
import PageHeader from '../../components/Shared/PageHeader'

export default function ViewAccountPage () {
  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const account = location?.state?.account || null

  const viewAccountColumns = [
    { field: 'name_en', header: t('name') },
    { field: 'type_en', header: t('type') },
    { field: 'sub_type_en', header: t('subType') },
    { field: 'balance', header: t('balance') },
    { field: 'description', header: t('description') }
  ]

  if (!account) {
    return (
      <div className='p-6'>
        <PageHeader title={t('account_details')} backPath={'/manager/accounts'} />
        <p className='mt-4'>{t('No_account_selected')}</p>
        
      </div>
    )
  }
  const data = [account]

  return (
    <div>
      <PageHeader title={t('account_details')} backPath={'/manager/accounts'} />
      <CustomTable data={data} columns={viewAccountColumns} />
    </div>
  )
}
